export const space = ' '
export const nbsp = '\u00a0'
export const emdash = '—'
export const disk = '•'
